import { createFragmentContainer, graphql } from "react-relay";
import JobEvent from "~/components/JobActivityTimeline/JobEvent";

type Props = {
  event: any;
  previousTimestamp: string | null | undefined;
};

function JobEventJobLogSizeExceeded({ event, previousTimestamp }: Props) {
  return (
    <JobEvent timestamp={event.timestamp} previousTimestamp={previousTimestamp}>
      <JobEvent.Label>Log Size Limit Exceeded</JobEvent.Label>
      <JobEvent.Description>
        Job canceled because the job log exceeded the maximum size limit.
      </JobEvent.Description>
    </JobEvent>
  );
}

export default createFragmentContainer(JobEventJobLogSizeExceeded, {
  event: graphql`
    fragment JobEventJobLogSizeExceeded_event on JobEvent {
      ... on JobEvent {
        timestamp
      }
    }
  `,
});
